import { Component, Input } from '@angular/core';
import { DocumentAttachment } from '@icc/b2b/shared';
import { SalesDocumentService } from '../sales-document.service';
import * as Sentry from '@sentry/angular-ivy';
@Component({
    selector: 'icc-sales-document-attachments',
    templateUrl: './sales-document-attachments.component.html',
    styleUrls: ['./sales-document-attachments.component.scss'],
})
export class SalesDocumentAttachmentsComponent {
    @Input() salesDocumentUuid!: string;
    @Input() positionUuid!: string;
    @Input() attachments: DocumentAttachment[] = [];
    @Input() isConfirmed = true;

    constructor(private salesDocumentService: SalesDocumentService) {}

    addAttachment(target) {
        let counter = 0;
        const files: File[] = target.files;
        for (const file of files) {

            if (this.salesDocumentService.validateFile(file)) {
                counter++;
                this.salesDocumentService.addAttachmentFromFile(
                    file,
                    this.salesDocumentUuid,
                    this.positionUuid
                );
            }
        }
        target.value = null;

        if (counter > 3) {
            Sentry.captureMessage('Too many attachments added at once', {
                level: 'warning',
                extra: {
                    attachmentsCount: counter,
                    salesDocumentId: this.salesDocumentUuid,
                    positionId: this.positionUuid,
                    files: files.map((file) => file.name),
                },
            });
        }
    }

    downloadAttachment(attachment: DocumentAttachment) {
        setTimeout(() => {
            const downloadLink = document.createElement('a');
            downloadLink.href = URL.createObjectURL(new Blob([attachment.data]));
            downloadLink.download = attachment.name;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }, 0);
    }

    removeAttachment(attachment: DocumentAttachment) {
        this.salesDocumentService.removeAttachment(attachment.uuid, this.salesDocumentUuid);
    }
}
